export default class ProblemItem {
    constructor(problemItemId, fnsku, quantity, orderId) {
        this.problemItemId = problemItemId;
        this.fnsku = fnsku;
        this.quantity = quantity;
        this.orderId = orderId;
    }
}